module.exports = __webpack_public_path__ + "img/old3.bd8dedd6.jpg";